import { ATTR_NAME } from 'constants/attr-name'
import { ScriptService } from 'services/script/script.service'
import { AbstractObserver } from 'utils/abstract-classes/abstract-observer'
import { isDomReady } from 'utils/dom'
import { logger } from 'utils/system/logger'
import { ISailthru } from './types'

const {
    widget: { sailthruPersonalizationEngine: attrName }
} = ATTR_NAME

export class SailthruPersonalizationEngine extends AbstractObserver {
    public static readonly scriptSource =
        'https://ak.sail-horizon.com/spm/spm.v1.min.js'
    public sailthru: ISailthru
    private accountId: string
    public constructor(protected el: HTMLElement) {
        super(el)
        this.activateObserver()
    }

    /**
     * Load the data and show the widget (if data was returned)
     */
    public render(): void {
        // Get Sailthru Bearer authorization from HTML template to authorize Sailthru calls
        const accountId = this.el.getAttribute(attrName.accountId)
        logger('info', 'rendering sailthru')
        logger('info', 'accountId:', accountId)
        if (!accountId) {
            return
        }
        this.accountId = accountId

        if (this.accountId) {
            this.loadSailthru().catch((err) => logger('error', err))
        } else {
            logger(
                'error',
                'Cannot initialize sailthru component, data-account-id required'
            )
        }
    }

    private async loadSailthru(): Promise<void> {
        await isDomReady()
        ScriptService.getInstance()
            .loadScript({
                name: 'sailthru-widget',
                src: SailthruPersonalizationEngine.scriptSource,
                loaded: false
            })
            .then(() => this.initSailthru())
            .catch((error: Error) => console.error(error))
    }

    /**
     * Initialize Sailthru Personalization Engine
     * https://getstarted.sailthru.com/site/personalization-engine/pe-setup/
     */
    private initSailthru(): void {
        try {
            this.sailthru = window.Sailthru
            this.sailthru.init({
                customerId: this.accountId
            })
            // dispatch event "sailthru-ready'
            window.dispatchEvent(new Event('sailthru-ready'))
            this.setSocialRegisterCookie()
        } catch (error) {
            logger('error', error)
        }
    }

    /**
     * Checks if the user came from a social register UTM source and sets a session cookie.
     * The cookie is shared across tabs (same browser session) and expires when the browser closes.
     */
    private setSocialRegisterCookie(): void {
        const urlParams = new URLSearchParams(window.location.search)
        const utmSource = urlParams.get('utm_reg')

        if (utmSource === 'social') {
            // Create session cookie — expires in 48h
            document.cookie = `utm_reg=social; max-age=${
                // eslint-disable-next-line no-magic-numbers
                48 * 60 * 60
            }; path=/; Secure; SameSite=Lax`
        }
    }
}
